// eslint-disable-next-line import/no-anonymous-default-export
export default {

  SECTION_a: "सामान्य जानकारी",
  SECTION_b: "परोसे गए भोजन की गुणवत्ता एवं मात्रा का मूल्यांकन",
  SECTION_c: "जल सुरक्षा",
  SECTION_d: "वितरण क्षेत्र की सामान्य स्वच्छता",
  SECTION_e: "सुरक्षा व्यवस्थाएँ",
  SECTION_f: "स्वच्छता",
  SECTION_g: "अपशिष्ट प्रबंधन",
  SECTION_h: "व्यक्तिगत स्वच्छता",
  SECTION_i: "खाद्य स्वच्छता",
  SECTION_j: "आईईसी एवं निगरानी",
  SECTION_k: "चुनौतियाँ एवं सुझाव",

  // Section A — General Information
  A1: "क्या कियोस्क प्रतिदिन, अवकाश के दिनों सहित, संचालित रहता है? यदि नहीं, तो प्रतिदिन संचालित न होने का कारण टिप्पणी कॉलम में लिखें।",
  A1_HELPER: "यूएलबी द्वारा जारी संबंधित आदेश अपलोड करें",
  A2: "क्या कियोस्क स्वयं सहायता समूहों (SHGs) द्वारा संचालित है या अन्य किसी द्वारा? यदि अन्य द्वारा संचालित है, तो टिप्पणी कॉलम में संचालक का विवरण तथा SHG को शामिल न करने का कारण लिखें।",
  A3: "कियोस्क के संचालन में लगे कर्मचारियों की संख्या बताएं",
  A4: "भोजन वितरण का समय (निर्देशानुसार समय दोपहर 12 बजे से 3 बजे तक)",
  A5: "प्रतिदिन लाभान्वित होने वाले लाभार्थियों की औसत संख्या",
  A6: "क्या खाद्य कूपनों की रसीदें भविष्य के संदर्भ एवं लेखा परीक्षण हेतु यूएलबी स्तर पर सुरक्षित रखी जाती हैं?",

  // Section B — Quality & Quantity Assessment of Served Food
  B1: "आप परोसे गए भोजन की गुणवत्ता को किस प्रकार मूल्यांकित करेंगे?",
  B2: "आप परोसे गए भोजन की मात्रा को किस प्रकार मूल्यांकित करेंगे?",
  B3: "क्या सभी निर्धारित खाद्य पदार्थ (जैसे चावल, दाल, सब्जी और एक पूर्ण टेबल अंडा) प्रतिदिन परोसे जाते हैं?",

  // Section C — Water Safety
  C1: "क्या कियोस्क में लाभार्थियों के लिए सुरक्षित एवं पीने योग्य पेयजल की व्यवस्था है?",
  C2: "यदि हाँ, तो लाभार्थियों को सुरक्षित पेयजल उपलब्ध कराने के लिए क्या व्यवस्था की गई है?",
  C2_HELPER: "पेयजल बिंदु का फोटो अपलोड करें",
  C3: "क्या पेयजल की रासायनिक एवं जीवाणुविज्ञान संबंधी जाँच प्रत्येक छह माह में की जाती है तथा उसका रिकॉर्ड सुरक्षित रखा जाता है?",
  C3_HELPER: "यदि हाँ, तो जल गुणवत्ता परीक्षण की अंतिम तिथि बताएं तथा संबंधित परीक्षण रिपोर्ट अपलोड करें।",

  // Section D — General cleanliness of distribution area
  "D.1": "क्या कियोस्क में भोजन वितरण के लिए पर्याप्त स्थान उपलब्ध है?",
  "D.2": "क्या कियोस्क में लाभार्थियों को भोजन संभालते और वितरित करते समय स्वच्छता का पालन किया जाता है? उपयुक्त विकल्प चुनें। यदि सभी स्वच्छता मानकों का पालन नहीं किया जाता है, तो टिप्पणी कॉलम में कमियों का उल्लेख करें।",
  "D.3": "क्या कियोस्क में भोजन वितरण से पहले और बाद में वितरण क्षेत्र की प्रतिदिन सफाई एवं सैनिटाइजेशन किया जाता है तथा क्या इसका रिकॉर्ड हाउसकीपिंग चेकलिस्ट में दर्ज किया जाता है? यदि सफाई का रिकॉर्ड प्रतिदिन दर्ज किया जाता है, तो 'हाँ' चुनें।",
  "D.3_HELPER": "सत्यापन हेतु नवीनतम हाउसकीपिंग रिकॉर्ड अपलोड करें।",
  "D.4": "आप कियोस्क की समग्र स्वच्छता को किस प्रकार मूल्यांकित करेंगे?",

  // Section E — Safety Arrangements
  "E.1": "क्या कियोस्क में लाभार्थियों को अत्यधिक गर्मी एवं वर्षा से बचाने हेतु ऊपर शेड की व्यवस्था उपलब्ध है?",
  "E.2": "क्या कियोस्क ऐसे स्थान पर स्थित है जहाँ जलभराव नहीं होता तथा बाढ़ की संभावना नहीं है?",

  // Section F — Sanitation
  "F.1": "क्या कियोस्क के निकट कैंटीन कर्मचारियों के लिए समर्पित एवं कार्यशील शौचालय उपलब्ध है? (*कार्यशील शौचालय का अर्थ है फ्लशिंग एवं सफाई के लिए बहता पानी, अवरोध-मुक्त शौचालय एवं मूत्रालय, कार्यशील सिस्टर्न, साबुन एवं पानी सहित वॉशबेसिन तथा उचित जल निकासी व्यवस्था उपलब्ध होना)।",
  "F.2": "क्या शौचालयों में पर्याप्त वेंटिलेशन, प्रकाश व्यवस्था तथा गोपनीयता बनी रहती है?",
  "F.3": "क्या शौचालयों की प्रतिदिन सफाई की जाती है तथा उसका रिकॉर्ड हाउसकीपिंग चेकलिस्ट में दर्ज किया जाता है? (यदि चेकलिस्ट प्रतिदिन अद्यतन है, तो 'हाँ' चुनें)",
  "F.4": "क्या कर्मचारियों के शौचालय में स्वच्छता अपशिष्ट निपटान हेतु ढक्कनयुक्त डस्टबिन उपलब्ध है?",
  "F.4_HELPER": "सत्यापन हेतु वर्तमान माह का हाउसकीपिंग रिकॉर्ड अपलोड करें",

  // Section G — Waste Management
  "G.1": "क्या कियोस्क के निकट कचरे के पृथक्करण (जैविक एवं अजैविक अपशिष्ट) हेतु रंगीन डस्टबिन (हरा एवं नीला) उपलब्ध हैं?",
  "G.2": "क्या कचरा पृथक्करण संबंधी IEC सामग्री डस्टबिन के निकट प्रदर्शित की गई है?",
  "G.2_HELPER": "सत्यापन हेतु फोटो अपलोड करें",
  "G.3": "क्या डस्टबिन को कचरा खाली करने के बाद प्रतिदिन साफ किया जाता है तथा उसका रिकॉर्ड हाउसकीपिंग चेकलिस्ट में दर्ज किया जाता है? (यदि रिकॉर्ड अद्यतन है, तो 'हाँ' चुनें)",
  "G.3_HELPER": "सत्यापन हेतु हाउसकीपिंग चेकलिस्ट रिकॉर्ड अपलोड करें",
  "G.4": "क्या कियोस्क में एकल-उपयोग प्लास्टिक का उपयोग किया जा रहा है?",

  // Section H — Hygiene
  "H.1": "क्या कर्मचारी भोजन वितरण एवं सफाई के दौरान उपयुक्त सुरक्षा उपकरण पहनते हैं? i. भोजन परोसते समय एप्रन, कैप, मास्क एवं फूड हैंडलिंग ग्लव्स ii. कियोस्क एवं आसपास की सफाई के दौरान एप्रन एवं उपयोगी दस्ताने।",
  "H.1_HELPER": "गतिविधियों के दौरान PPE पहने हुए कर्मचारियों का फोटो अपलोड करें",
  "H.2": "क्या भोजन वितरण स्थल के निकट कर्मचारियों एवं लाभार्थियों के लिए कार्यशील हाथ धोने की व्यवस्था उपलब्ध है? (*कार्यशील हाथ धोने की व्यवस्था में बहता पानी, साबुन, बिना टूटे एवं बिना रिसाव वाले नल तथा उचित जल निकासी प्रणाली से जुड़ा आउटलेट पाइप होना चाहिए।) यदि उपरोक्त सभी सुविधाएँ उपलब्ध हैं, तो 'हाँ' चुनें।",
  "H.2_HELPER": "कियोस्क क्षेत्र के निकट हाथ धोने की व्यवस्था का फोटो अपलोड करें",
  "H.3": "क्या हाथ धोने के स्थान या नाली के आसपास जलभराव है?",
  "H.4": "क्या कर्मचारी भोजन परोसने से पहले एवं कियोस्क की सफाई के बाद हाथ धोने के 6 चरणों से परिचित हैं और उनका पालन करते हैं? (हाथ धोने के अवसर देखें - 1. भोजन परोसने से पहले 2. शौचालय उपयोग के बाद 3. कियोस्क की सफाई के बाद)",
  "H.5": "क्या कर्मचारियों का प्रत्येक छह माह में स्वास्थ्य परीक्षण किया जाता है तथा उसका रिकॉर्ड सुरक्षित रखा जाता है?",
  "H.5_HELPER": "सत्यापन हेतु नवीनतम रिकॉर्ड अपलोड करें",
  "H.6": "क्या कर्मचारी व्यक्तिगत स्वच्छता बनाए रखते हैं (जैसे नेल पॉलिश न लगाना, नाखून कटे होना, बाल ढके होना आदि)?",

  // Section I — Food Hygiene
  "I.1": "लाभार्थियों को भोजन परोसने के लिए किस प्रकार की प्लेटों का उपयोग किया जाता है? यदि अन्य सामग्री या लागू नहीं है, तो टिप्पणी कॉलम में प्रयुक्त प्लेट की सामग्री अथवा भोजन वितरण की व्यवस्था का उल्लेख करें।",

  // Section J — IEC & Monitoring
  "J.1": "क्या हाथ धोने, सुरक्षित शौचालय उपयोग आदि संबंधी पोस्टर कैंटीन में प्रदर्शित किए गए हैं?",
  "J.2": "क्या ऑनलाइन पोर्टल में नियमित ऑनलाइन प्रविष्टियाँ की जा रही हैं?",
  "J.3": "क्या दैनिक प्रविष्टियों का वितरित कूपनों की संख्या से मिलान किया जाता है?",

  // Section K — Challenges & Suggestion
  "1": "चुनौतियाँ (यदि कोई हों)",
  "2": "सुझाव (यदि कोई हों)",
};